import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { Container } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Cookies from 'js-cookie';
import api from "../../API/ApiLink.js";
import CardDetails from "../../Components/CardDetails/CardDetails.js";
import { useParams } from "react-router-dom";
import CommentCardAds from "../../Components/Comments/CommentCardAds.js";
import AddCommentAds from "../../Components/Comments/AddCommentAds.js";
import Share from "../../Components/Cards/Share.js";
import OverPage from "../../Components/OverPage/OverPage.js";
import NotFoundPage from './../NotFoundPage/NotFoundPage';
import QuickCardDetails from "../../Components/CardDetails/QuickCardDetails.js";
import usePageSEO from "../../hooks/usePageSEO";

const MoreDeteliesPage = () => {
  const { slug } = useParams();
  const [over, setOver] = useState(true);
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true); // State for loading

  const property = data && data !== "NotFound" ? data.ad?.property : null;
  const canonicalSlug = property?.slug || slug;
  const seoTitle = property
    ? `${property["Arabic Name"]} - ${property["Sub Category"] || ""} ${property.Type || ""} ${property.city || ""} | فارندا`.trim()
    : "تفاصيل العقار | فارندا";
  const seoDescription = property
    ? (property.details_ar || "")
        .replace(/<[^>]*>/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 160) ||
      `${property["Arabic Name"]} - ${property["Sub Category"] || ""} ${property.Type || ""} في ${property.city || ""}، ${property.governorate || ""}`
    : "تصفح تفاصيل العقار على فارندا - الموقع الأول للعقارات في مصر";
  const seoImage = property?.primary_picture || property?.images?.[0]?.image;
  const seoUrl = `https://varnda.com/property/${encodeURIComponent(canonicalSlug)}`;
  const seoKeywords = property
    ? [
        property["Arabic Name"],
        property["Sub Category"],
        property.Type,
        property.governorate,
        property.city,
        property.region,
        property.compound,
        "عقارات",
        "فارندا",
      ].filter(Boolean)
    : ["عقارات", "فارندا"];

  usePageSEO({
    title: seoTitle,
    description: seoDescription,
    keywords: seoKeywords,
    canonical: seoUrl,
    img: seoImage,
    url: seoUrl,
  });

  useEffect(() => {
    const getOneAds = async () => {
      try {
        setLoading(true); // Set loading to true before API call
        const token = Cookies.get("token");
        const response = await api.get(`/getAd/${slug}`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const adsData = response.data.data;
        setData(adsData);
      } catch (err) {
        if (err.response?.data?.status === 404) {
          setData("NotFound");
        }
      } finally {
        setOver(false);
        setLoading(false); // Set loading to false after API call
      }
    };
    getOneAds();
  }, [slug]);

  return (
    <>
      {loading && ( // Loader element
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
      {data === "NotFound" ? (
        <NotFoundPage />
      ) : data === "" ? (
        <></>
      ) : (
        <>
          <Header />
          {data.ad.ad_type ? (
            <QuickCardDetails
              propertyDetails={data.ad}
              relatedProperties={data.related_properties}
            />
          ) : (
            <CardDetails
              propertyDetails={data.ad}
              relatedProperties={data.related_properties}
            />
          )}
          <hr />
          <Container>
            <CommentCardAds ads_id={slug} />
            <hr />
            <AddCommentAds ads_id={slug} />
          </Container>
          <Footer />
          {data.ad && (
            <Share
              text={data.ad.property["Arabic Name"]}
              url={`https://varnda.com/property/${encodeURIComponent(canonicalSlug)}`}
            />
          )}
          {over && <OverPage />}
        </>
      )}
    </>
  );
};

export default MoreDeteliesPage;
